import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { toggleReviewReminders as toggleReviewRemindersAction } from 'Redux/ducks/auth';

const ReviewReminders = ({ review_reminders: reviewReminders, toggleReviewReminders }) => {
  const toggleNotifications = () => {
    toggleReviewReminders(!reviewReminders);
  };

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage id="account.setting.title.reviews" defaultMessage="Fanatical Service Review Email Notifications" />
      </div>
      <div className="account-table-row-content">
        <div className="account-table-details-container">
          {reviewReminders &&
            <span className="highlighted-text">
              <FormattedMessage id="account.setting.reviews.enabled" defaultMessage="Enabled" />
            </span>
          }
          {!reviewReminders &&
            <FormattedMessage id="account.setting.reviews.disabled" defaultMessage="Disabled" />
          }
        </div>
        <div className="account-table-action-container">
          <button type="button" className="account-table-action-button" onClick={() => toggleNotifications()}>
            {reviewReminders &&
              <FormattedMessage id="account.setting.button.reviews.disable" defaultMessage="Disable Service Review Notifications" />
            }
            {!reviewReminders &&
              <FormattedMessage id="account.setting.button.reviews.enable" defaultMessage="Enable Service Review Notifications" />
            }
          </button>
        </div>
      </div>
    </div>
  );
};

ReviewReminders.propTypes = {
  review_reminders: PropTypes.bool,
  toggleReviewReminders: PropTypes.func.isRequired,
};

ReviewReminders.defaultProps = {
  review_reminders: true,
};


const mapStateToProps = ({
  auth: { review_reminders }, // eslint-disable-line camelcase
}) => ({
  review_reminders,
});

const mapDispatchToProps = {
  toggleReviewReminders: toggleReviewRemindersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReminders);
